import { getSubDomainName } from "@/assets/js/common.js"

const domain = getSubDomainName()
import(`@/assets/scss/themes-app/app-${domain || 'monceaux'}.scss`)
